module.exports = __webpack_public_path__ + "img/output-5.761a02fd.png";